import { render, staticRenderFns } from "./FormBoxTextarea.vue?vue&type=template&id=22bdf6c2&scoped=true"
import script from "./FormBoxTextarea.vue?vue&type=script&lang=js"
export * from "./FormBoxTextarea.vue?vue&type=script&lang=js"
import style0 from "./FormBoxTextarea.vue?vue&type=style&index=0&id=22bdf6c2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bdf6c2",
  null
  
)

export default component.exports